export const NAME = 'multi-template-preview';

export const PDF_MEDIUM_QUALITY = 2;
export const XLS_FILE = 6;
